import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import types, {commonPageKey} from './types';
import {Action, handleAsyncActions} from 'redux/helpers';
import {IDiplomatObject} from 'types/DiplomatObject';
import {packId} from 'common/diplomatIdUtil';
import {keyTypes} from 'redux/keys';
import {partnersTypes} from 'redux/partners';
import {transactionsTypes} from 'redux/transactions';
import {sftpUsersTypes} from 'redux/sftp-user';
import {synchronizationsTypes} from 'redux/synchronizations';
import {FormOnSubmitOutsideHelpers} from 'components/hook-form/Formik';

export const initialCommonPageState = {
   isFetching: false,
   error: null,
   cache: {},
   data: {} as IDiplomatObject,
   dirtyValuesGetter: {} as {
      [packedId: string]: FormOnSubmitOutsideHelpers<any>;
   },
   proxies: [] as IDiplomatObject[],
};

const updateCache = (cache: any, payload: any) => ({
   ...cache,
   [payload.id]: payload,
});

const commonPageReducer = (_state = initialCommonPageState, action: Action) => {
   const state = handleAsyncActions(_state, action, types, {
      exclude: [types.REFETCH_DATA.REQUEST],
   });

   switch (action.type) {
      case types.GET_DATA.REQUEST:
         return {
            ...state,
            data: {} as IDiplomatObject,
            isFetching: true,
            error: null,
         };
      case types.GET_DATA.ERROR:
         return {
            ...state,
            isFetching: false,
            data: {} as IDiplomatObject,
            error: action.payload,
         };
      case types.GET_DATA.SUCCESS:
      case types.REFETCH_DATA.SUCCESS:
      case types.UPDATE_PARTNER.SUCCESS:
         return {
            ...state,
            cache: updateCache(state.cache, action.payload),
            data: action.payload,
            isFetching: false,
            error: null,
         };
      case transactionsTypes.UPDATE_TRANSACTION.SUCCESS:
         return {
            ...state,
            cache: updateCache(state.cache, action.payload.transaction),
            data: action.payload.transaction,
            isFetching: false,
            error: null,
         };
      case synchronizationsTypes.UPDATE_SYNCHRONIZATION.SUCCESS:
         return {
            ...state,
            cache: updateCache(state.cache, action.payload.synchronization),
            data: action.payload.synchronization,
            isFetching: false,
            error: null,
         };

      case types.UPDATE_CACHE_DATA.SUCCESS:
         return {
            ...state,
            cache: updateCache(state.cache, action.payload),
         };

      case keyTypes.MOVE_KEYS.SUCCESS:
      case partnersTypes.MOVE_PARTNER.SUCCESS:
      case transactionsTypes.MOVE_TRANSACTION.SUCCESS:
      case synchronizationsTypes.MOVE_SYNCHRONIZATION.SUCCESS:
      case sftpUsersTypes.MOVE_SFTP_USER.SUCCESS:
      case sftpUsersTypes.MOVE_SFTP_GROUP.SUCCESS:
         return {
            ...state,
            data: {
               ...state.data,
               timestamp: action.payload?.[0]?.timestamp || action.payload?.timestamp,
               folderId: action.payload?.[0]?.folderId || action.payload?.folderId,
            },
         };

      case types.GET_PROXIES.SUCCESS:
         return {
            ...state,
            ...action.payload,
         };

      case types.PERSIST_DIRTY_VALUES_GETTER: {
         let {objectType, id, ...helpers} = action.payload;
         return {
            ...state,
            dirtyValuesGetter: {
               ...state.dirtyValuesGetter,
               [packId(objectType, id)]: helpers,
            },
         };
      }
      case types.FLUSH_DIRTY_VALUES_GETTER: {
         let {objectType, id} = action.payload;
         let newDirtyValues = {...state.dirtyValuesGetter};
         delete newDirtyValues[packId(objectType, id)];
         return {
            ...state,
            dirtyValuesGetter: newDirtyValues,
         };
      }

      default:
         return state;
   }
};

let reducer = commonPageReducer;
const config = {
   key: commonPageKey,
   storage: storage,
   whitelist: ['forms'],
   // blacklist: ['error', 'isFetching', 'cache'],
};
reducer = persistReducer(config, commonPageReducer) as any;

export default reducer;
